export default __webpack_public_path__ + "static/media/waspnest3.6325aa0f.png";